import { useState, useEffect, useRef, useMemo, Fragment } from "react";
import axios from 'axios';
import { Modal } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';
import limpiarHtml from '../Compartido/limpiarHtml.js';
import { useBl } from '../Compartido/modoBl.js';
import { avisarExtrasNuevos, claveExtra, salidaFilasExtras } from "../Compartido/avisoExtras";

const DatosReserva = ({ propiedades, llegada, salida, difdias, adultos, ninos, bebes, distribucion = [], lang, ruta, config, tpvs, paypal, transferencia, stripe, paycomet, moneda, websgrupo, paises }) => {

    const bl = useBl();

    let { t } = useTranslation();

    let token = document.getElementById("meta_token").getAttribute("content");

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    let precioBase = useMemo(() => {
        return propiedades.reduce(
            (total, propiedad) =>
                total + Number(propiedad.precios.suma || 0) / 100,
            0
        );
    }, [propiedades]);

    let cuentaNoches = difdias;
    let sumaextras = 0;


    let resextras = [];

    const sumaExtrasRef = useRef(0);
    const sumaExtras2Ref = useRef(0);
    const pextraRef = useRef(null);
    const feesRef = useRef(0);


    const [precioExtras, setPrecioExtras] = useState(0);

    const [prepagoRef, setPrepagoRef] = useState(propiedades[0].precios.info_tarifa.politica.prepago);

    const [detallesAbiertos, setDetallesAbiertos] = useState({});
    const toggleDetalles = (key) => setDetallesAbiertos((prev) => ({ ...prev, [key]: !prev[key] }));

    useEffect(() => {
        pintarExtrasResumen();
    }, [detallesAbiertos]);

    const [modalPolitica, setModalPolitica] = useState(null);

    // llegada/salida arriben com "YYYY-MM-DD" — es mostren DD/MM/YYYY,
    // mateix format que Buscar2/PropiedadesBuscar.jsx.
    const formatoFechaLlarga = (data) => {
        if (!data) return "";
        const parts = data.split("-");
        return parts.length === 3 ? parts[2] + "/" + parts[1] + "/" + parts[0] : data;
    };

    const [mostrarExtras, setMostrarExtras] = useState(propiedades[0].relacion_extras.length == 0 ? 'none' : "block");

    const [mostrarDescuento, setMostrarDescuento] = useState(mostrarExtras == "block" ? "none" : "block");

    const [mostrarDadesClient, setMostrarDadesClient] = useState("none");

    const [mostrarInfoPago, setMostrarInfoPago] = useState("none");

    const [mostrarInfoTarjeta, setMostrarInfoTarjeta] = useState("none");

    const [mostrarPagar, setMostrarPagar] = useState("none");

    const toggleTarifasDescuento = (e) => {
        e.stopPropagation();
        setMostrarExtras("none");
        setMostrarDescuento("block");
        irAlSiguientePaso();
    };

    const toggleExtresTarifas = (e) => {
        e.stopPropagation();
        setMostrarExtras("block");
        setMostrarDescuento("none");
        irAlSiguientePaso();
    };

    const toggleDescuentoDadesClient = (e) => {
        e.stopPropagation();
        setMostrarDescuento("none");
        setMostrarDadesClient("block");
        irAlSiguientePaso();
    };

    const toggleDadesClientDescuento = (e) => {
        e.stopPropagation();
        setMostrarDescuento("block");
        setMostrarDadesClient("none");
        irAlSiguientePaso();
    };

    const toggleDadesClientInfoPago = (e) => {
        e.stopPropagation();
        setMostrarDadesClient("none");
        setMostrarInfoPago("block");
        setMostrarPagar("block");
        irAlSiguientePaso();
    };

    const toggleDadesInfoPagoClient = (e) => {
        e.stopPropagation();
        setMostrarDadesClient("block");
        setMostrarInfoPago("none");
        setMostrarPagar("none");
        irAlSiguientePaso();
    };

    {/* *************** */ }

    const [cantApartRef, setCantApartRef] = useState(propiedades.length);

    const aceptacondicionesRef = useRef(null);
    const phoneDropdownRef = useRef(null);

    const codigodescuentoprecioRef = useRef(null);
    const codigodescuentoporcentajeRef = useRef(null);

    const formularioreservaRef = useRef(null);

    const [importePrepago, setImportePrepago] = useState(0);

    const [showHayExtraCat, setShowHayExtraCat] = useState("none");

    const numtarjetaRef = useRef(null);
    const titulartarjetaRef = useRef(null);
    const fechacaducidadtarjetaRef = useRef(null);
    const cvctarjetaRef = useRef(null);

    const [cardErrors, setCardErrors] = useState({ num: null, expiry: null, cvc: null });

    const luhn = (num) => {
        const digits = num.replace(/\D/g, '');
        if (digits.length < 13 || digits.length > 19) return false;
        let sum = 0;
        let alt = false;
        for (let i = digits.length - 1; i >= 0; i--) {
            let n = parseInt(digits[i], 10);
            if (alt) { n *= 2; if (n > 9) n -= 9; }
            sum += n;
            alt = !alt;
        }
        return sum % 10 === 0;
    };

    const validateExpiry = (val) => {
        const match = val.match(/^(0[1-9]|1[0-2])\/(\d{2})$/);
        if (!match) return false;
        const now = new Date();
        const expMonth = parseInt(match[1], 10);
        const expYear = 2000 + parseInt(match[2], 10);
        return expYear > now.getFullYear() || (expYear === now.getFullYear() && expMonth >= now.getMonth() + 1);
    };

    const formatCardNumber = (e) => {
        const raw = e.target.value.replace(/\D/g, '').slice(0, 19);
        e.target.value = raw.replace(/(.{4})/g, '$1 ').trim();
        numtarjetaRef.current.dataset.raw = raw;
    };

    const handleCardBlur = (field) => {
        const errors = { ...cardErrors };
        if (field === 'num') {
            const raw = (numtarjetaRef.current.dataset.raw || numtarjetaRef.current.value).replace(/\D/g, '');
            errors.num = luhn(raw) ? null : t('Número de tarjeta no válido');
        }
        if (field === 'expiry') {
            errors.expiry = validateExpiry(fechacaducidadtarjetaRef.current.value) ? null : t('Fecha caducada o formato incorrecto (MM/AA)');
        }
        if (field === 'cvc') {
            errors.cvc = /^\d{3,4}$/.test(cvctarjetaRef.current.value) ? null : t('CVV debe tener 3 o 4 dígitos');
        }
        setCardErrors(errors);
    };

    const isCardValid = () =>
        luhn((numtarjetaRef.current?.dataset.raw || numtarjetaRef.current?.value || '').replace(/\D/g, '')) &&
        validateExpiry(fechacaducidadtarjetaRef.current?.value || '') &&
        /^\d{3,4}$/.test(cvctarjetaRef.current?.value || '');

    {/* *************** */ }

    const roundN = (value, decimals) => {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    }

    // Amb diverses habitacions cada extra ja porta el seu propi selector per
    // habitació (només compta un cop), així que no s'ha de tornar a
    // multiplicar pel nombre d'habitacions com es feia amb el selector global.
    const multiHabitacio = propiedades.length > 1;
    const factorExtras = multiHabitacio ? 1 : Number(cantApartRef);

    const handleChangeTarifa = () => {

        console.log("Cambio tarifa " + cantApartRef);

        var precioEstancia = Number(precioBase);

        var precioExtras = Number(feesRef.current.value);

        var precioTotal = Number(precioEstancia);

        const elprepago = Number(
            prepagoRef || 0
        );

        if (elprepago === 0 && transferencia) {
            const transferenciaRadio = document.getElementById("payments4");
            if (transferenciaRadio) {
                transferenciaRadio.checked = true;
            }
        }

        var totalextratipo2 = 0;

        var nombresextras = "";

        var extras = document.getElementsByClassName("extra");
        for (var i = 0; i < extras.length; i++) {
            var unextra = extras[i];
            if (unextra.getAttribute('data-tipoextra') === 2) {
                var porciento = unextra.getAttribute('data-precio');
                var precioextra = (precioEstancia * porciento) / 100;
                var valorcampo = unextra.value;
                if (valorcampo == 1) {
                    totalextratipo2 += precioextra;
                }
            }
        }

        var precioextrascal = 0;

        for (var i = 0; i < extras.length; i++) {
            var unextra = extras[i];
            var valorcampo = unextra.value;
            if (unextra.getAttribute("data-nombre") && valorcampo == 1) {
                nombresextras += (nombresextras == "" ? "" : " ") + unextra.getAttribute("data-nombre");

                var elprecioExtra = parseFloat(unextra.getAttribute('data-precio')) / 100 * (unextra.hasAttribute('data-habitacion') ? 1 : propiedades.length);

                var tipoextra = parseInt(unextra.getAttribute('data-tipoextra'));

                var porreserva = parseInt(unextra.getAttribute('data-porreserva'));
                var porpersona = parseInt(unextra.getAttribute('data-porpersona'));
                var pordia = parseInt(unextra.getAttribute('data-pordia'));
                var pormes = parseInt(unextra.getAttribute('data-pormes'));

                var personas = parseInt(unextra.getAttribute('data-numpersonas'));
                var difdias = parseInt(unextra.getAttribute('data-numdias'));

                if (porreserva) {
                    elprecioExtra = elprecioExtra * 1;
                }
                if (porpersona) {
                    elprecioExtra = elprecioExtra * personas;
                }
                if (pordia) {
                    elprecioExtra = elprecioExtra * difdias;
                }
                if (pormes) {
                    elprecioExtra = elprecioExtra * (difdias / 30);
                }
                precioextrascal += elprecioExtra;

            }
        }

        sumaExtras2Ref.current.value = totalextratipo2;

        if (!isNaN(sumaExtrasRef.current.value)) {
            var nuevoPrecioExtras = roundN(precioextrascal, 2) * factorExtras;
            feesRef.current.value = nuevoPrecioExtras;
        }
        else {
            var nuevoPrecioExtras = 0;
            feesRef.current.value = 0;
        }

        if (!isNaN(sumaExtras2Ref.current.value)) {
            var nuevoPrecioExtrasTipo2 = roundN(sumaExtras2Ref.current.value, 2) * factorExtras;
            var fees = roundN(feesRef.current.value, 2);

            feesRef.current.value = parseFloat(nuevoPrecioExtrasTipo2) + parseFloat(fees);
        }
        else {
            var nuevoPrecioExtrasTipo2 = 0;
        }

        var nuevoPrecioTotal = roundN(parseFloat(precioEstancia) + parseFloat(nuevoPrecioExtras) + parseFloat(nuevoPrecioExtrasTipo2), 2);

        let incremento = 0;
        let tipoIncremento = 0;

        const payment = document.querySelector("input[name='payments']:checked");

        if (!payment) {
            return;
        }

        incremento = payment.getAttribute("data-incremento");
        tipoIncremento = payment.getAttribute("data-tipoincremento");

        let incremento2 = incremento;
        if (tipoIncremento === 1) {
            incremento2 = roundN(Number(nuevoPrecioTotal) * ((Number(incremento) / 100)), 2);
        }

        if (incremento > 0) {
            let incremento_a_mostrar = 0;
            if (tipoIncremento === 0) {
                nuevoPrecioTotal = roundN(Number(nuevoPrecioTotal) + Number(incremento), 2);
                incremento_a_mostrar = roundN(Number(incremento), 2);
            } else {
                incremento_a_mostrar = roundN(Number(nuevoPrecioTotal) * (Number(incremento) / 100), 2);
                nuevoPrecioTotal = roundN(Number(nuevoPrecioTotal) * (1 + (Number(incremento) / 100)), 2);
            }
            setShowHayExtraCat("flex");
        }
        else {
            setShowHayExtraCat("none");
        }

        var nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
        var nuevoResto = nuevoPrecioTotal - nuevoPrepago;

        var codigoDescuentoPrecio = codigodescuentoprecioRef.current.value;
        var codigoDescuentoPorcentaje = codigodescuentoporcentajeRef.current.value;

        if (codigoDescuentoPrecio > 0 || codigoDescuentoPorcentaje > 0) {
            var precioSinDescuento = nuevoPrecioTotal;
        }
        else {
            var precioSinDescuento = 0.00;
        }
        if (codigoDescuentoPrecio > 0) {
            nuevoPrecioTotal = (nuevoPrecioTotal - codigoDescuentoPrecio).toFixed(2);
            nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
            nuevoResto = nuevoPrecioTotal - nuevoPrepago;
        }
        if (codigoDescuentoPorcentaje > 0) {
            nuevoPrecioTotal = (nuevoPrecioTotal - (precioEstancia * (codigoDescuentoPorcentaje / 100))).toFixed(2);
            nuevoPrepago = (nuevoPrecioTotal * prepago) / 100;
            nuevoResto = nuevoPrecioTotal - nuevoPrepago;
        }

        document.querySelectorAll(".totalprice").forEach(function (elemento) {
            elemento.textContent = roundN(Number(nuevoPrecioTotal), 2) + " " + moneda;
        });

        document.querySelectorAll(".feesincluded").forEach(function (elemento) {
            elemento.textContent = roundN(Number(incremento2), 2)
        });

        if (codigoDescuentoPrecio > 0 || codigoDescuentoPorcentaje > 0) {
            if (codigoDescuentoPrecio > 0) {
                document.querySelector(".codigo-carro").textContent = "-" + parseFloat(codigoDescuentoPrecio).toFixed(2);
            }
            if (codigoDescuentoPorcentaje > 0) {
                document.querySelector(".codigo-carro").textContent = "-" + (precioEstancia * (codigoDescuentoPorcentaje / 100)).toFixed(2);
            }
        }

        setPrepagoRef(elprepago);

        nuevoPrepago = (Number(nuevoPrecioTotal) * elprepago) / 100;
        nuevoResto = Number(nuevoPrecioTotal) - nuevoPrepago;

        setImportePrepago(nuevoPrepago);

        document.querySelectorAll(".prepago").forEach(function (elemento) {

            if (document.getElementById("payments4") && document.getElementById("payments4").checked) {
                elemento.textContent = ""
                document.getElementById("titulopagar").textContent = t("Confirmar");
                document.getElementById("titulopagarmobile").textContent = t("Confirmar");
                document.getElementById("pagarmoneda").textContent = ""
            }
            else {

                if (nuevoPrepago > 0) {

                    elemento.textContent = roundN(Number(nuevoPrepago), 2)

                    document.getElementById("titulopagar").textContent = t("Pagar") + " " + t("Ahora")
                    document.getElementById("titulopagarmobile").textContent = t("Pagar") + " " + t("Ahora")
                    document.getElementById("pagarmoneda").textContent = moneda
                }
                else {

                    elemento.textContent = ""
                    document.getElementById("titulopagar").textContent = t("Confirmar");
                    document.getElementById("titulopagarmobile").textContent = t("Confirmar")
                    document.getElementById("pagarmoneda").textContent = ""
                }
            }
        });

        if (elprepago === 0) {
            if (document.getElementById("payments1"))
                document.getElementById("payments1").required = false;
            if (document.getElementById("payments2"))
                document.getElementById("payments2").required = false;
        }
        if (elprepago > 0) {
            if (document.getElementById("payments1"))
                document.getElementById("payments1").required = true;
            if (document.getElementById("payments2"))
                document.getElementById("payments2").required = true;
            if (document.getElementById("payments5"))
                document.getElementById("payments5").required = true;
            if (document.getElementById("payments6"))
                document.getElementById("payments6").required = true;
        }

        const pagoTransferencia = document.getElementById("payments4") && document.getElementById("payments4").checked;

        const mostrarTarjeta = Number(elprepago) < 100 || pagoTransferencia;

        if (mostrarTarjeta) {
            setMostrarInfoTarjeta("block")
            document.getElementById("numtarjeta").required = true;
            document.getElementById("titulartarjeta").required = true;
            document.getElementById("fechacaducidadtarjeta").required = true;
            document.getElementById("cvctarjeta").required = true;
        }
        else {
            setMostrarInfoTarjeta("none");
            document.getElementById("numtarjeta").required = false;
            document.getElementById("titulartarjeta").required = false;
            document.getElementById("fechacaducidadtarjeta").required = false;
            document.getElementById("cvctarjeta").required = false;

        }

    }

    // Extres triats de cada habitació dins "Detalles" (targeta de la dreta).
    // Els contenidors (data-extras-hab) no tenen fills de React: s'omplen
    // aquí, directament al DOM, pel mateix motiu que els interruptors (un
    // re-render reescriuria els imports dels inputs ocults).
    const extrasPrevRef = useRef(null);

    const pintarExtrasResumen = () => {
        const elegidos = [...document.querySelectorAll("select.extra")].filter(sel => sel.value === "1");
        const nuevos = avisarExtrasNuevos(elegidos, extrasPrevRef);
        document.querySelectorAll("[data-extras-hab]").forEach((cont) => {
            const k = Number(cont.getAttribute("data-extras-hab"));
            const selects = [...document.querySelectorAll("select.extra")].filter(sel =>
                sel.value === "1" && (!sel.hasAttribute("data-habitacion") || Number(sel.getAttribute("data-habitacion")) === k)
            );
            const viejas = [...cont.querySelectorAll(".bh-cart__extra[data-clave]")];
            cont.innerHTML = "";
            if (selects.length === 0) {
                cont.textContent = "—";
                salidaFilasExtras(cont, viejas);
                return;
            }
            selects.forEach((sel) => {
                let precio = parseFloat(sel.getAttribute("data-precio")) / 100;
                if (parseInt(sel.getAttribute("data-porpersona"))) precio *= parseInt(sel.getAttribute("data-numpersonas"));
                if (parseInt(sel.getAttribute("data-pordia"))) precio *= parseInt(sel.getAttribute("data-numdias"));
                if (parseInt(sel.getAttribute("data-pormes"))) precio *= parseInt(sel.getAttribute("data-numdias")) / 30;
                const fila = document.createElement("div");
                fila.className = "bh-cart__extra" + (nuevos.has(claveExtra(sel)) ? " bh-cart__extra--nuevo" : "");
                const nom = document.createElement("span");
                nom.textContent = sel.getAttribute("data-nombrebase") || sel.getAttribute("data-nombre");
                const preu = document.createElement("strong");
                preu.textContent = roundN(precio, 2) + " " + moneda;
                fila.appendChild(nom);
                fila.appendChild(preu);
                fila.setAttribute("data-clave", claveExtra(sel));
                cont.appendChild(fila);
            });
            salidaFilasExtras(cont, viejas);
        });
    };

    // A cada pas: puja suaument a dalt de tot i fa entrar el bloc nou amb
    // una petita animació, perquè quedi clar que s'ha canviat de pas (si no,
    // amb molts extres es quedava la pantalla en blanc més avall).
    const irAlSiguientePaso = () => {
        requestAnimationFrame(() => {
            const paso = [...document.querySelectorAll(".metro-box-wrapper")].find(w => w.style.display === "block");
            const menu = document.querySelector(".navbar.menu");
            const margen = (menu ? menu.getBoundingClientRect().height : 0) + 24;
            const destino = paso ? paso.getBoundingClientRect().top + window.scrollY - margen : 0;
            window.scrollTo({ top: Math.max(0, destino), behavior: "smooth" });
            if (paso && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
                paso.classList.remove("bh-paso-entra");
                void paso.offsetWidth;
                paso.classList.add("bh-paso-entra");
            }
        });
    };

    // Extres per habitació: cada extra té un selector ocult per habitació
    // (extra{id}_h{n}) que el càlcul de sota ja sap llegir. L'aspecte dels
    // interruptors es canvia directament al DOM, sense estat de React: un
    // re-render reescriuria el defaultValue dels inputs ocults (baseextras,
    // fees) i esborraria els imports que el càlcul hi acaba d'escriure.
    const personasHabitacion = (k) => (
        distribucion.length === propiedades.length
            ? Number(distribucion[k].adultos) + Number(distribucion[k].ninos)
            : Number(adultos) + Number(ninos)
    );

    const pintarExtraHabitacion = (idExtra) => {
        const selects = [...document.querySelectorAll("select[name^='extra" + idExtra + "_h']")];
        selects.forEach((sel) => {
            const chip = document.querySelector("[data-chip='" + sel.name + "']");
            if (chip) {
                chip.classList.toggle("bh-extra-hab--activa", sel.value === "1");
                chip.setAttribute("aria-pressed", sel.value === "1" ? "true" : "false");
            }
        });
        const master = document.querySelector("[data-master='" + idExtra + "']");
        if (master) master.checked = selects.some(sel => sel.value === "1");
    };

    const cambiarExtraHabitacion = (idExtra, k, activo) => {
        const nombre = "extra" + idExtra + "_h" + k;
        const select = document.querySelector("select[name='" + nombre + "']");
        const nuevo = activo ? "1" : "0";
        if (!select || select.value === nuevo) return;
        select.value = nuevo;
        handleChangeExtra(nombre);
        pintarExtraHabitacion(idExtra);
    };

    const cambiarExtraTodas = (idExtra, activo) => {
        propiedades.forEach((_, k) => cambiarExtraHabitacion(idExtra, k, activo));
    };

    const handleChangeExtra = (param) => {

        var elemento = document.querySelector("select[name='" + param + "']");

        var valor = elemento.value;
        var precioExtra = parseFloat(elemento.getAttribute('data-precio')) / 100 * (elemento.hasAttribute('data-habitacion') ? 1 : propiedades.length);
        var baseExtras = parseFloat(sumaExtrasRef.current.value);
        var baseExtrasTipo2 = parseFloat(sumaExtras2Ref.current.value);

        var precioBaseCE = precioBase;
        var precioExtraTarifa = precioExtras;

        precioBaseCE = precioBaseCE - precioExtraTarifa;

        var tipoextra = parseInt(elemento.getAttribute('data-tipoextra'));

        var porreserva = parseInt(elemento.getAttribute('data-porreserva'));
        var porpersona = parseInt(elemento.getAttribute('data-porpersona'));
        var pordia = parseInt(elemento.getAttribute('data-pordia'));
        var pormes = parseInt(elemento.getAttribute('data-pormes'));

        var personas = parseInt(elemento.getAttribute('data-numpersonas'));
        var difdias = parseInt(elemento.getAttribute('data-numdias'));

        if (porreserva) {
            precioExtra = precioExtra * 1;
        }
        if (porpersona) {
            precioExtra = precioExtra * personas;
        }
        if (pordia) {
            precioExtra = precioExtra * difdias;
        }
        if (pormes) {
            precioExtra = precioExtra * (difdias / 30);
        }

        if (tipoextra === 0) {
            if (valor === "0") {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) - Number(precioExtra), 2);
            }

            else {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) + Number(precioExtra), 2);
            }
        }
        else if (tipoextra === 1) {
            if (valor === "0") {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) - Number(precioExtra), 2);
            }

            else {
                sumaExtrasRef.current.value = roundN(Number(baseExtras) + Number(precioExtra), 2);
            }
        }
        else if (tipoextra === 2) {
            precioExtra = (Number(elemento.getAttribute('data-preciohab') ?? precioBase) * precioExtra) / 100;

            if (valor === "0") {
                sumaExtras2Ref.current.value = roundN(Number(baseExtrasTipo2) - Number(precioExtra), 2);

            }
            else {
                sumaExtras2Ref.current.value = roundN(Number(baseExtrasTipo2) + Number(precioExtra), 2);
            }
        }

        feesRef.current.value = (parseFloat(sumaExtrasRef.current.value) + parseFloat(sumaExtras2Ref.current.value)) * factorExtras;

        handleChangeTarifa();

        pintarExtrasResumen();

    }

    const handleChangeDiscount = () => {

        var el = document.querySelector('#nombrecodigo');

        let parameters = location.search.substring(1);
        var incrementotpv = 0;

        if (document.querySelector("input[type='radio'][name='payments1']") && document.querySelector("input[type='radio'][name='tarifa1']:checked")) {
            incrementotpv = Number(document.querySelector("input[type='radio'][name='tarifa1']:checked").getAttribute("data-incremento"));
        }
        if (document.querySelector("#payments2") && document.querySelector("#payments2").checked) {
            incrementotpv = Number(document.querySelector("#payments2").getAttribute("data-incremento"));
        }
        if (document.querySelector("#payments5") && document.querySelector("#payments5").checked) {
            incrementotpv = Number(document.querySelector("#payments5").getAttribute("data-incremento"));
        }

        var precioEstancia = Number(document.querySelector(".tarifa1:checked").value);
        var precioExtras = Number(document.querySelector("#datosreserva").getAttribute('data-extras0'));
        var precioTotal = Number(Number(precioEstancia) + Number(precioExtras));
        var incremento = roundN((precioTotal * (incrementotpv / 100)), 2);
        var preciotpv = roundN((Number(precioTotal) + Number(incremento)), 2);
        var pagoaCuenta = roundN(preciotpv * (Number(document.querySelector(".tarifa1:checked").getAttribute('data-prepago')) / 100), 2);

        const result = axios.post('check-cliente-reserva', {
            idCodigoDescuento: el.value,
            propiedad: propiedades[0].idpropiedad,
            entrada: llegada,
            salida: salida,
            parameters: parameters,
            dataType: 'JSON'
        })
            .then((response) => {
                const solucion = response.data;
                if (solucion.status === "success") {
                    var descuento;
                    if (solucion.tipo === 'moneda') {
                        descuento = parseFloat(solucion.descuento).toFixed(2);
                        codigodescuentoprecioRef.current.value = descuento;
                    } else {
                        descuento = (precioEstancia * (solucion.descuento / 100)).toFixed(2);
                        codigodescuentoporcentajeRef.current.value = solucion.descuento;
                    }

                    pagoaCuenta = roundN((preciotpv - descuento) * (Number(document.querySelector(".tarifa1:checked").getAttribute('data-prepago')) / 100), 2);

                    var resto = Number(preciotpv - descuento - pagoaCuenta);

                    document.querySelector('.codigo-carro').innerHTML = "<span>-" + descuento + "</span> ";
                    document.querySelector('.muestra-codigo-carro').style.display = "";
                    document.querySelector('#codigodescuento div').innerHTML = '<div class="ws-errorbox" style="display: block;" id="errorbox-1"><p class="ws-errormessage c008">Codigo de descuento valido.</p></div>';
                    document.querySelector('.prepago').textContent = roundN(Number(pagoaCuenta), 2) + " " + moneda;
                    handleChangeTarifa();
                }
                else {
                    codigodescuentoprecioRef.current.value = "";
                    codigodescuentoporcentajeRef.current.value = "";
                    var resto = preciotpv - pagoaCuenta;
                    document.querySelector('.muestra-codigo-carro').style.display = "none";
                    document.querySelector('.codigo-carro').textContent = '';
                    document.querySelector('#codigodescuento div').innerHTML = '<div class="ws-errorbox" style="display: block;" id="errorbox-1"><p class="ws-errormessage">Codigo de descuento no valido.</p></div>';
                    document.querySelector('.prepago').textContent = roundN(Number(pagoaCuenta), 2) + " " + moneda;
                    handleChangeTarifa();
                }
            })
    };

    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => {
        setShowModal(!showModal);
    }

    const [enviando, setEnviando] = useState(false);

    const handleSubmit = async () => {

        console.log("hago submit");

        const pagoTransferencia = document.getElementById("payments4") && document.getElementById("payments4").checked;

        if (formData.firstname && formData.firstname.replace(/\s+/g, '').length > 0 &&
            formData.lastname && formData.lastname.replace(/\s+/g, '').length > 0 &&
            formData.email && formData.email.replace(/\s+/g, '').length > 0 &&
            formData.phone && formData.phone.replace(/\s+/g, '').length > 0 &&
            formData.documentousuario && formData.documentousuario.replace(/\s+/g, '').length > 0 &&
            aceptacondicionesRef.current.checked && formData.email.includes('@')) {
            if (prepagoRef < 100 || pagoTransferencia) {
                if (titulartarjetaRef.current.value.trim().length > 0 && isCardValid()) {
                    const raw = (numtarjetaRef.current.dataset.raw || numtarjetaRef.current.value).replace(/\D/g, '');
                    numtarjetaRef.current.value = raw;
                    setEnviando(true);
                    formularioreservaRef.current.submit();
                }
                else {
                    handleShowModal()
                }
            }
            else {
                console.log("no pido tarjeta");
                setEnviando(true);
                formularioreservaRef.current.submit();
            }
        }
        else {
            handleShowModal()
        }
    }

    const handleBack = () => {
        window.history.back();
    }

    useEffect(() => {

        if (document.getElementById("payments2")) {
            document.getElementById("payments2").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }

        if (document.getElementById("payments5")) {
            document.getElementById("payments5").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }


        if (document.getElementById("payments4")) {
            document.getElementById("payments4").addEventListener("click", function () {
                handleChangeTarifa();
            })
        }

        if (document.querySelector(".tpv")) {
            document.querySelector(".tpv").click(function () {
                handleChangeTarifa();
            });
        }

        if (document.querySelector(".bizum")) {
            document.querySelector(".bizum").click(function () {
                handleChangeTarifa();
            });
        }

        setTimeout(() => {
            handleChangeTarifa();
        }, 0);

    }, []);

    const [showMore, setshowMore] = useState(-1);

    {/* *************** */ }
    // 1. Primero, define el estado y la función para manejar los cambios
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        documentousuario: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    {/* *************** Prefijo telefónico *************** */ }

    const isoToFlag = (iso) => {
        if (!iso || iso.length !== 2) return '🌐';
        return String.fromCodePoint(...[...iso.toUpperCase()].map((c) => 127397 + c.charCodeAt(0)));
    };

    const [selectedCountry, setSelectedCountry] = useState(paises && paises.length > 0 ? paises[0] : null);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneDropdownOpen, setPhoneDropdownOpen] = useState(false);
    const [phoneSearch, setPhoneSearch] = useState('');

    const filteredPaises = useMemo(() => {
        return (paises || []).filter(unpais =>
            unpais.nombre
                .toLowerCase()
                .includes(phoneSearch.toLowerCase())
        );
    }, [paises, phoneSearch]);

    useEffect(() => {
        const prefijo = selectedCountry ? selectedCountry.prefijo : '';
        setFormData((prev) => ({ ...prev, phone: (prefijo + phoneNumber).trim() }));
    }, [selectedCountry, phoneNumber]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (phoneDropdownRef.current && !phoneDropdownRef.current.contains(e.target)) {
                setPhoneDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    {/* *************** */ }

    // 2. Calcula si el formulario es válido
    const isFormValid = formData.firstname && formData.lastname &&
        formData.email && phoneNumber.trim().length > 0 &&
        formData.documentousuario;

    {/* *************** */ }

    useEffect(() => {
        if (mostrarInfoPago === "block") {
            setTimeout(() => {
                handleChangeTarifa();
            }, 0);
        }
    }, [mostrarInfoPago, prepagoRef, cantApartRef]);

    {/* *************** */ }

    precioBase = useMemo(() => {
        return propiedades.reduce(
            (total, propiedad) =>
                total + Number(propiedad.precios.suma || 0) / 100,
            0
        );
    }, [propiedades]);

    {/* *************** */ }

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-7 col-lg-8">

                    <form method="post" action="/resumenhotel" id="formularioreserva" ref={formularioreservaRef}>
                        <input type="hidden" name="_token" value={token} />
                        {bl && <input type="hidden" name="bl" value="1" />}
                        <input type="hidden" name="llegada" defaultValue={llegada} id="llegada" />
                        <input type="hidden" name="salida" defaultValue={salida} id="salida" />
                        <input type="hidden" name="adultos" defaultValue={adultos} />
                        <input type="hidden" name="distribucion" defaultValue={distribucion.map(h => h.adultos + "-" + h.ninos).join(";")} />
                        <input type="hidden" name="ninos" defaultValue={ninos} />
                        <input type="hidden" name="bebes" defaultValue={bebes} />
                        <input type="hidden" name="discount" id="discount" defaultValue="0" />
                        <input type="hidden" name="fees" id="fees" defaultValue={propiedades[0].fees / 100} ref={feesRef} />
                        <input type="hidden" name="idusuario" id="user" defaultValue="" />
                        <input type="hidden" name="difdias" defaultValue={difdias} />

                        <input type="hidden" name="prepago" id="prepago" defaultValue={prepagoRef} />
                        <input type="hidden" name="solorequest" id="solorequest" defaultValue="0" />
                        <input type="hidden"
                            name="propiedades"
                            defaultValue={JSON.stringify(
                                propiedades.map(propiedad => ({
                                    id: propiedad.id,
                                    tarifa: propiedad.precios.id
                                }))
                            )}
                        />

                        {/* ***************** EXTRES ***************** */}

                        <div className="metro-box-wrapper" style={{ display: mostrarExtras }}>
                            <h3>{t("Extras")}</h3>
                            <div className="linia"></div>

                            <div className="content">
                                <p className="text-muted">{t("Mejore su estancia con los siguientes extras.")}</p>

                                {propiedades[0].relacion_extras.map((unextra, index) => {

                                    let baseprecio = unextra.precio;
                                    let dias_a_multiplicar = Math.min(difdias, propiedades[0].destino.maximo_dias);

                                    if (unextra.obligatorio) {
                                        let tipo_precio = unextra.tipo_precio;
                                        if (tipo_precio === "1") {
                                            if (unextra.por_persona === 1) {
                                                baseprecio = baseprecio * (Number(adultos) + Number(ninos))
                                            }
                                            if (unextra.por_dia_reserva === 1) {
                                                baseprecio = baseprecio * difdias;
                                            }
                                        }
                                        else {
                                            baseprecio = precioBase * (baseprecio / 100);
                                            if (unextra.por_persona === 1) {
                                                baseprecio = baseprecio * (Number(adultos) + Number(ninos))
                                            }
                                            if (unextra.por_dia_reserva === 1) {
                                                baseprecio = baseprecio * dias_a_multiplicar;
                                            }
                                        }
                                        sumaextras += (baseprecio / 100)
                                    }

                                    if (unextra.incluido) return null;

                                    // Només les habitacions la propietat de les quals ofereix aquest extra.
                                    const habitacionesConExtra = propiedades
                                        .map((p, k) => (p.relacion_extras.some(e => e.servicios_extra_id === unextra.servicios_extra_id) ? k : -1))
                                        .filter(k => k >= 0);

                                    const periodo = unextra.por_reserva ? " / " + t("Por reserva")
                                        : unextra.por_persona ? " / " + t("Por persona")
                                            : unextra.por_dia_reserva ? " / " + t("Por dia")
                                                : unextra.por_mes_reserva ? " / " + t("Por mes")
                                                    : "";

                                    return (
                                        <div className="gap-3 p-3 mb-3 bg-white border rounded-3 d-flex align-items-center flex-wrap serveismotor" key={"e" + index} data-key={"e" + index}>
                                            <div className="flex-shrink-0 p-3 d-flex align-items-center justify-content-center bg-light rounded-3">
                                                {unextra.imagen ?
                                                    <i className={unextra.imagen.replace("fa-lg", "") + " fa-xl text-secondary"}></i>
                                                    :
                                                    <i className="fa-duotone fa-check fa-xl text-secondary"></i>
                                                }
                                            </div>
                                            <div className="flex-grow-1">
                                                <div className="fw-semibold">{unextra.nombre}</div>
                                                {!unextra.obligatorio &&
                                                    <div className="text-muted small">
                                                        <strong>{(baseprecio / 100).toFixed(2)} {moneda}</strong>{periodo}
                                                    </div>
                                                }
                                            </div>
                                            {!!unextra.descripcion &&
                                                <div className="extra-descripcion text-muted small" dangerouslySetInnerHTML={{ __html: unextra.descripcion }}></div>
                                            }
                                            <div className="flex-shrink-0 extra-toggle">
                                                {unextra.obligatorio ?
                                                    <span className="px-2 py-1 border badge bg-light text-success border-success">
                                                        {t("Incluido")}
                                                    </span>
                                                    :
                                                    <div className="mb-0 form-check form-switch switch-lg">
                                                        {multiHabitacio ? (
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                title={t("Todas las habitaciones")}
                                                                data-master={unextra.servicios_extra_id}
                                                                defaultChecked={false}
                                                                onChange={(e) => cambiarExtraTodas(unextra.servicios_extra_id, e.target.checked)}
                                                            />
                                                        ) : (
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                defaultChecked={false}
                                                                onChange={(e) => {
                                                                    document.querySelector(`select[name="extra${unextra.servicios_extra_id}"]`).value = e.target.checked ? "1" : "0";
                                                                    handleChangeExtra("extra" + unextra.servicios_extra_id);
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                }
                                            </div>
                                            {multiHabitacio && !unextra.obligatorio ? (
                                                <>
                                                    <div className="w-100 bh-extra-habs">
                                                        <span className="bh-extra-habs__etiqueta">{t("Aplicar a")}</span>
                                                        {habitacionesConExtra.map((k) => {
                                                            const nombreSel = "extra" + unextra.servicios_extra_id + "_h" + k;
                                                            return (
                                                                <button
                                                                    type="button"
                                                                    key={nombreSel}
                                                                    data-chip={nombreSel}
                                                                    className="bh-extra-hab"
                                                                    aria-pressed="false"
                                                                    onClick={() => cambiarExtraHabitacion(
                                                                        unextra.servicios_extra_id, k,
                                                                        document.querySelector("select[name='" + nombreSel + "']").value !== "1"
                                                                    )}
                                                                >
                                                                    <span>{t("Habitación")} {k + 1}</span>
                                                                    {distribucion.length === propiedades.length && (
                                                                        <small>{distribucion[k].adultos} {distribucion[k].adultos == 1 ? t("Adulto") : t("Adultos")}{distribucion[k].ninos > 0 ? ", " + distribucion[k].ninos + " " + (distribucion[k].ninos == 1 ? t("Niño") : t("Niños")) : ""}</small>
                                                                    )}
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                    {habitacionesConExtra.map((k) => {
                                                        const extraHab = propiedades[k].relacion_extras.find(e => e.servicios_extra_id === unextra.servicios_extra_id);
                                                        return (
                                                            <select
                                                                key={"sel" + k}
                                                                className="d-none extra"
                                                                name={"extra" + unextra.servicios_extra_id + "_h" + k}
                                                                data-habitacion={k}
                                                                data-preciohab={Number(propiedades[k].precios.suma || 0) / 100}
                                                                data-dialimpieza=""
                                                                data-nombre={unextra.nombre + " (" + t("Habitación") + " " + (k + 1) + ")"}
                                                                data-nombrebase={unextra.nombre}
                                                                data-extraid={unextra.servicios_extra_id}
                                                                data-precio={extraHab.precio}
                                                                data-porreserva={extraHab.por_reserva ? 1 : 0}
                                                                data-porpersona={extraHab.por_persona ? 1 : 0}
                                                                data-pordia={extraHab.por_dia_reserva ? 1 : 0}
                                                                data-pormes={extraHab.por_mes_reserva ? 1 : 0}
                                                                data-numdias={difdias}
                                                                data-numpersonas={personasHabitacion(k)}
                                                                data-tipoextra={extraHab.tipo}
                                                                defaultValue={0}
                                                            >
                                                                <option value="0">0</option>
                                                                <option value="1">1</option>
                                                            </select>
                                                        );
                                                    })}
                                                </>
                                            ) : (
                                                                                        <select
                                                className="d-none extra"
                                                name={"extra" + unextra.servicios_extra_id}
                                                disabled={unextra.obligatorio ? true : false}
                                                data-dialimpieza=""
                                                data-nombre={unextra.nombre}
                                                data-nombrebase={unextra.nombre}
                                                data-extraid={unextra.servicios_extra_id}
                                                data-precio={baseprecio}
                                                data-porreserva={unextra.por_reserva ? 1 : 0}
                                                data-porpersona={unextra.por_persona ? 1 : 0}
                                                data-pordia={unextra.por_dia_reserva ? 1 : 0}
                                                data-pormes={unextra.por_mes_reserva ? 1 : 0}
                                                data-numdias={difdias}
                                                data-numpersonas={Number(adultos) + Number(ninos)}
                                                data-tipoextra={unextra.tipo}
                                                defaultValue={unextra.obligatorio ? 1 : 0}
                                            >
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                            </select>
                                            )}
                                            {!!unextra.obligatorio &&
                                                <input type="hidden" name={"extra" + unextra.servicios_extra_id} defaultValue={1} />
                                            }
                                        </div>
                                    );
                                })}

                                <input type="hidden" name="baseextras" id="baseextras" defaultValue={sumaextras} ref={sumaExtrasRef} />
                                <input type="hidden" name="baseextrastipo2" id="baseextrastipo2" defaultValue="0" ref={sumaExtras2Ref} />
                            </div>
                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center">
                                <button type="button"
                                    onClick={toggleTarifasDescuento}
                                    className="btn btn-primary"
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {t("Siguiente")} →
                                </button>
                            </div>
                        </div>


                        {/* ***************** FINAL EXTRES ***************** */}

                        {/* ***************** CODI DESCOMPTE ***************** */}
                        <div className="metro-box-wrapper" style={{ display: mostrarDescuento }}>
                            <h3>{t("Código promocional")}</h3>
                            <div className="linia"></div>

                            <div className="gap-2 p-3 mt-5 mb-4 border border-opacity-25 d-flex align-items-start rounded-3 bg-primary bg-opacity-10 border-primary">
                                <i className="flex-shrink-0 mt-1 fa-duotone fa-circle-info fa-lg text-primary"></i>
                                <small className="text-secondary fw-normal lh-base">
                                    {t("Si dispones de un código de descuento, introdúcelo en el campo correspondiente. El importe se actualizará automáticamente antes de confirmar tu reserva.")}
                                </small>
                            </div>

                            <div className="content">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-8 col-lg-6">
                                        <label className="mb-2 form-label fw-normal">{t("Código de descuento")}</label>
                                        <div id="codigodescuento" className="input-group">
                                            <input type="text" className="form-control" placeholder={t("Introduce tu código")} name="codigodescuento" id="nombrecodigo" onKeyUp={handleChangeDiscount} />
                                            <span className="input-group-text">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M4 4.85v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.9v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.9v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.9v.9h1v-.9zm7 0v.9h1v-.9z" />
                                                    <path d="M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3zM1 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.05a2.5 2.5 0 0 0 0 4.9v1.05a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.05a2.5 2.5 0 0 0 0-4.9z" />
                                                </svg>
                                            </span>
                                        </div>
                                        <input type="hidden" id="codigodescuentoprecio" name="codigodescuentoprecio" defaultValue="" ref={codigodescuentoprecioRef} />
                                        <input type="hidden" id="codigodescuentoporcentaje" name="codigodescuentoporcentaje" defaultValue="" ref={codigodescuentoporcentajeRef} />
                                        <input type="hidden" name="moneda2" defaultValue={moneda} />
                                        <input type="hidden" name="abreviaturamoneda2" defaultValue="EUR" />
                                    </div>
                                </div>
                            </div>

                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center align-items-center">
                                <button type="button"
                                    onClick={toggleExtresTarifas}
                                    className="btn btn-outline-secondary"
                                >
                                    ← {t("Anterior")}
                                </button>
                                <button type="button"
                                    onClick={toggleDescuentoDadesClient}
                                    className="btn btn-primary"
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {t("Siguiente")} →
                                </button>
                            </div>

                        </div>
                        {/* ***************** FINAL CODI DESCOMPTE ***************** */}

                        {/* ***************** DADES CLIENT ***************** */}

                        <div className="metro-box-wrapper" id="userInfo" style={{ display: mostrarDadesClient }}>
                            <h3>{t("Información de cobro")}</h3>
                            <div className="linia"></div>
                            <div className="content">
                                <div className="row g-3">
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Nombre")} *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Nombre")}
                                            name="firstname"
                                            required
                                            value={formData.firstname}
                                            onChange={handleInputChange}
                                            id="nombrec"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Apellidos")} *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Apellidos")}
                                            name="lastname"
                                            required
                                            value={formData.lastname}
                                            onChange={handleInputChange}
                                            id="apellidosc"
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Email")} *</label>
                                        <input
                                            id="emailc"
                                            type="email"
                                            className="form-control"
                                            placeholder={t("Email")}
                                            name="email"
                                            required
                                            value={formData.email}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Teléfono")} *</label>
                                        <div className="d-flex position-relative" ref={phoneDropdownRef}>
                                            <button
                                                type="button"
                                                className="gap-2 px-2 border btn d-flex align-items-center"
                                                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 'none' }}
                                                onClick={() => setPhoneDropdownOpen((prev) => !prev)}
                                            >
                                                <span>{isoToFlag(selectedCountry?.iso)}</span>
                                                <span>{selectedCountry?.prefijo || ''}</span>
                                                <i className="fa-solid fa-chevron-down fa-xs"></i>
                                            </button>
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                                placeholder={t("Teléfono")}
                                                required
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                id="telefonoc"
                                            />
                                            <input type="hidden" name="phone" value={formData.phone} />

                                            {phoneDropdownOpen &&
                                                <div className="bg-white border shadow-sm position-absolute rounded-3" style={{ top: '100%', left: 0, zIndex: 1000, width: '280px', marginTop: '4px' }}>
                                                    <div className="p-2 border-bottom">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder={t("Buscar")}
                                                            value={phoneSearch}
                                                            onChange={(e) => setPhoneSearch(e.target.value)}
                                                            autoFocus
                                                        />
                                                    </div>
                                                    <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                                                        {filteredPaises.map((unpais) => (
                                                            <div
                                                                key={unpais.id}
                                                                className="gap-2 px-3 py-2 cursor-pointer d-flex align-items-center"
                                                                style={{ cursor: 'pointer' }}
                                                                onMouseDown={() => {
                                                                    setSelectedCountry(unpais);
                                                                    setPhoneDropdownOpen(false);
                                                                    setPhoneSearch('');
                                                                }}
                                                            >
                                                                <span>{isoToFlag(unpais.iso)}</span>
                                                                <span>{unpais.nombre}</span>
                                                                <span className="text-muted ms-auto small">{unpais.prefijo}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Pasaporte/ID")} *</label>
                                        <input
                                            id="documentoc"
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Pasaporte/ID")}
                                            name="documentousuario"
                                            required
                                            value={formData.documentousuario}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">{t("Ciudad")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Ciudad")}
                                            name="city"
                                            defaultValue=""
                                        />
                                    </div>
                                    <div className="col-12 col-md-12">
                                        <label className="mt-1 col-md-6 col-lg-2">{t("Comentario")}</label>
                                        <div className="mb-2 col-md-6 col-lg-12">
                                            <textarea id="comentario" className="mb-0 form-control" rows="4" placeholder={t("Comentario")} name="comentario" />
                                        </div>
                                    </div>
                                    <div className="col-12 text-end">
                                        <small className="text-muted">{t("Todos los campos * son obligatorios")}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center">
                                <button type="button"
                                    onClick={toggleDadesClientDescuento}
                                    className="btn btn-outline-secondary"
                                >
                                    ← {t("Anterior")}
                                </button>
                                <button
                                    type="button"
                                    onClick={isFormValid ? toggleDadesClientInfoPago : undefined}
                                    className={`btn btn-primary${!isFormValid ? ' disabled' : ''}`}
                                    disabled={!isFormValid}
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {t("Siguiente")} →
                                </button>
                            </div>
                        </div>

                        {/* ***************** FINAL DADES CLIENT ***************** */}

                        {/* ***************** TPV, PAYPAL, ETC ***************** */}
                        <div className="metro-box-wrapper tipopago" style={{ display: mostrarInfoPago }}>
                            <h3>{t("Información de pago")}</h3>
                            <div className="linia"></div>
                            <div className="content">
                                <div id="paymentOption" className="payment-option-wrapper">
                                    <div className="row">
                                        {config.activa_tpv === 1 && tpvs.length > 0 && prepagoRef > 0 ?
                                            tpvs.map((untpv, index) => (

                                                <Fragment key={"tpv" + index}>
                                                    <div className="col-lg-6 col-md-12" data-key={"tpv" + index}>
                                                        <div className="radio-block font-icon-radio">
                                                            <input className="payments1 radio tpv"
                                                                id="elem0" name="payments"
                                                                type="radio"
                                                                defaultValue={"paymentsCreditCard" + untpv.id}
                                                                required=""
                                                                data-incremento={untpv.markup ? untpv.markup.incremento : 0}
                                                                data-idtpv={untpv.id}
                                                                data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0}
                                                                onClick={() => handleChangeTarifa()}
                                                                defaultChecked={index === 0}
                                                            />
                                                            <label htmlFor="elem0">

                                                                {untpv.nombre_comercio} <i className="fa-brands fa-cc-visa fa-xl"></i>

                                                            </label>
                                                        </div>
                                                    </div>

                                                    {untpv.bizum == 1 ?
                                                        <>
                                                            <div className='col-lg-6 col-md-12' key={"bizum" + index} data-key={"bizum" + index}>
                                                                <div className='radio-block font-icon-radio'>
                                                                    <input className='payments1 radio tpv'
                                                                        id='elem2-0'
                                                                        name='payments'
                                                                        type='radio'
                                                                        value={"paymentsBizum" + untpv.id}
                                                                        required=""
                                                                        data-incremento={untpv.markup ? untpv.markup.incremento : 0}
                                                                        data-idtpv={untpv.id}
                                                                        data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0}
                                                                        onClick={() => handleChangeTarifa()}
                                                                    />
                                                                    <label htmlFor='elem2-0'>

                                                                        {t("Bizum")} <i className="fa-duotone fa-mobile fa-xl"></i>

                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        <></>
                                                    }

                                                    {untpv.google_pay == 1 ?
                                                        <>
                                                            <div className='col-lg-6 col-md-12' key={"gp" + index}>
                                                                <div className='radio-block font-icon-radio'>
                                                                    <input className='payments1 radio tpv'
                                                                        id='elem2-0'
                                                                        name='payments'
                                                                        type='radio'
                                                                        value={"paymentsGPay" + untpv.id}
                                                                        required=""
                                                                        data-incremento={untpv.markup ? untpv.markup.incremento : 0}
                                                                        data-idtpv={untpv.id}
                                                                        data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0}
                                                                        onClick={() => handleChangeTarifa()}
                                                                    />
                                                                    <label htmlFor='elem2-0'>

                                                                        {t("Google")} <i className="fa-brands fa-google-pay fa-2xl ms-2"></i>

                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        <></>
                                                    }

                                                    {untpv.apple_pay == 1 ?
                                                        <>
                                                            <div className='col-lg-6 col-md-12' key={"ap" + index}>
                                                                <div className='radio-block font-icon-radio'>
                                                                    <input className='payments1 radio tpv'
                                                                        id='elem2-0'
                                                                        name='payments'
                                                                        type='radio'
                                                                        value={"paymentsAPay" + untpv.id}
                                                                        required=""
                                                                        data-incremento={untpv.markup ? untpv.markup.incremento : 0}
                                                                        data-idtpv={untpv.id}
                                                                        data-tipoincremento={untpv.markup ? untpv.markup.tipo : 0}
                                                                        onClick={() => handleChangeTarifa()}
                                                                    />
                                                                    <label htmlFor='elem2-0'>

                                                                        {t("Apple")} <i className="fa-brands fa-apple-pay fa-2xl ms-2"></i>

                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        <></>
                                                    }
                                                </Fragment>

                                            ))
                                            :
                                            <></>
                                        }
                                        {config.activa_paypal === 1 && paypal && prepagoRef > 0 ?
                                            <>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="radio-block font-icon-radio">
                                                        <input id="payments2"
                                                            name="payments"
                                                            type="radio"
                                                            className="radio"
                                                            value="paymentPaypal"
                                                            required=""
                                                            data-incremento={paypal.markup.incremento}
                                                            data-tipoincremento={paypal.markup.tipo}
                                                            onClick={() => handleChangeTarifa()}
                                                            defaultChecked={tpvs.length === 0}
                                                        />
                                                        <label htmlFor="payments2">

                                                            {t("Paypal")} <i className="fa-brands fa-paypal fa-xl"></i>

                                                        </label>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }

                                        {config.activa_stripe === 1 && stripe.length > 0 && prepagoRef > 0 ?
                                            stripe.map((unstripe, index) => (
                                                <Fragment key={"str" + index}>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="radio-block font-icon-radio">
                                                            <input className="payments5 radio"
                                                                name="payments"
                                                                type="radio"
                                                                value={"paymentStripe" + unstripe.id}
                                                                required=""
                                                                data-incremento={unstripe.markup.incremento}
                                                                data-tipoincremento={unstripe.markup.tipo}
                                                                onClick={() => handleChangeTarifa()}
                                                                defaultChecked={tpvs.length === 0 && config.activa_paypal === 0}
                                                                id="payments5"
                                                            />
                                                            <label htmlFor="payments5">

                                                                {unstripe.nombre_comercio && unstripe.nombre_comercio != '' ? unstripe.nombre_comercio : "Stripe"} <i className="fa-brands fa-stripe fa-xl"></i>

                                                            </label>
                                                        </div>
                                                    </div>
                                                </Fragment>
                                            ))
                                            :
                                            <></>
                                        }

                                        {config.activa_transferencia === 1 && transferencia ?
                                            <>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="radio-block font-icon-radio">
                                                        <input id="payments4"
                                                            name="payments"
                                                            type="radio"
                                                            className="radio"
                                                            value="paymentTransferencia"
                                                            required=""
                                                            onClick={() => handleChangeTarifa()}
                                                            defaultChecked={(tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0) || prepagoRef === 0}
                                                        />
                                                        <label htmlFor="payments4">

                                                            {transferencia.nombre_web} <i className="fa-duotone fa-building fa-xl"></i>

                                                        </label>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <></>
                                        }
                                        {config.activa_paycomet === 1 && paycomet && prepagoRef > 0 ?
                                            <>
                                                {
                                                    Object.keys(paycomet.metodos_pago).map((key) => (
                                                        <div className="col-lg-6 col-md-12" key={"pc" + key} data-key={"pc" + key}>
                                                            <div className="radio-block font-icon-radio">
                                                                <input id="payments6"
                                                                    name="payments"
                                                                    type="radio"
                                                                    className="radio payments6"
                                                                    value={"paymentPaycomet" + key}
                                                                    required=""
                                                                    onClick={() => handleChangeTarifa()}
                                                                    defaultChecked={tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0 && config.activa_transferencia === 0 && key == 1}
                                                                />
                                                                <label htmlFor="payments6">

                                                                    {paycomet.metodos_pago[key].nombre}
                                                                    {
                                                                        paycomet.metodos_pago[key].nombre === "Tarjeta" ?
                                                                            <i className="fa-brands fa-cc-visa fa-xl ms-2"></i>
                                                                            :
                                                                            paycomet.metodos_pago[key].nombre === "PayPal" ?
                                                                                <i className="fa-brands fa-paypal fa-xl ms-2"></i>
                                                                                :
                                                                                <i className="fa-duotone fa-mobile fa-xl ms-2"></i>
                                                                    }

                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                {
                                                    paycomet.apple_pay === 1 ?
                                                        <div className="col-lg-6 col-md-12">
                                                            <div className="radio-block font-icon-radio">
                                                                <input id="payments6"
                                                                    name="payments"
                                                                    type="radio"
                                                                    className="radio payments6"
                                                                    value="paymentPaycomet1"
                                                                    required=""
                                                                    onClick={() => handleChangeTarifa()}
                                                                />
                                                                <label htmlFor="payments6">

                                                                    {t("Apple")} <i className="fa-brands fa-apple-pay fa-2xl ms-2"></i>

                                                                </label>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                {
                                                    paycomet.google_pay === 1 ?
                                                        <div className="col-lg-6 col-md-12">
                                                            <div className="radio-block font-icon-radio">
                                                                <input id="payments6"
                                                                    name="payments"
                                                                    type="radio"
                                                                    className="radio payments6"
                                                                    value="paymentPaycomet1"
                                                                    required=""
                                                                    onClick={() => handleChangeTarifa()}
                                                                />
                                                                <label htmlFor="payments6">

                                                                    {t("Google")} <i className="fa-brands fa-google-pay fa-2xl ms-2"></i>

                                                                </label>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </>
                                            :
                                            <></>
                                        }



                                        <div className="p-4 mt-4 col-md-12 serveismotor" style={{ display: mostrarInfoTarjeta }}>
                                            <div className="gap-2 p-3 mt-2 mb-5 border border-opacity-25 d-flex align-items-start rounded-3 bg-primary bg-opacity-10 border-primary">
                                                <i className="flex-shrink-0 mt-1 fa-duotone fa-circle-info fa-lg text-primary"></i>
                                                <small className="text-secondary fw-normal lh-base">
                                                    {t("No te cobraremos nada todavía. Solo necesitamos los datos de la tarjeta para garantizar tu reserva.")}
                                                </small>
                                            </div>
                                            <div className="row g-3">
                                                <div className="col-12">
                                                    <label className="text-black form-label fw-bolder">{t("Titular de la tarjeta")} *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder={t("Titular de la tarjeta")}
                                                        name="titular_tarjeta"
                                                        onChange={handleInputChange}
                                                        id="titulartarjeta"
                                                        ref={titulartarjetaRef}
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <label className="text-black form-label fw-bolder">{t("Número de tarjeta")} *</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control${cardErrors.num === null && numtarjetaRef.current?.value ? ' is-valid' : cardErrors.num ? ' is-invalid' : ''}`}
                                                        placeholder="0000 0000 0000 0000"
                                                        name="num_tarjeta"
                                                        id="numtarjeta"
                                                        inputMode="numeric"
                                                        maxLength="19"
                                                        ref={numtarjetaRef}
                                                        onChange={formatCardNumber}
                                                        onBlur={() => handleCardBlur('num')}
                                                    />
                                                    {cardErrors.num && <div className="invalid-feedback">{cardErrors.num}</div>}
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label className="text-black form-label fw-bolder">{t("Fecha caducidad")} *</label>
                                                    <input
                                                        id="fechacaducidadtarjeta"
                                                        type="text"
                                                        className={`form-control${cardErrors.expiry === null && fechacaducidadtarjetaRef.current?.value ? ' is-valid' : cardErrors.expiry ? ' is-invalid' : ''}`}
                                                        placeholder="MM/AA"
                                                        name="fecha_caducidad"
                                                        maxLength="5"
                                                        inputMode="numeric"
                                                        ref={fechacaducidadtarjetaRef}
                                                        onChange={(e) => {
                                                            let v = e.target.value.replace(/\D/g, '').slice(0, 4);
                                                            if (v.length >= 3) v = v.slice(0, 2) + '/' + v.slice(2);
                                                            e.target.value = v;
                                                        }}
                                                        onBlur={() => handleCardBlur('expiry')}
                                                    />
                                                    {cardErrors.expiry && <div className="invalid-feedback">{cardErrors.expiry}</div>}
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label className="text-black form-label fw-bolder">{t("CVV / CVC")} *</label>
                                                    <input
                                                        type="password"
                                                        className={`form-control${cardErrors.cvc === null && cvctarjetaRef.current?.value ? ' is-valid' : cardErrors.cvc ? ' is-invalid' : ''}`}
                                                        placeholder="•••"
                                                        name="cvc_tarjeta"
                                                        maxLength="4"
                                                        inputMode="numeric"
                                                        id="cvctarjeta"
                                                        ref={cvctarjetaRef}
                                                        onChange={handleInputChange}
                                                        onBlur={() => handleCardBlur('cvc')}
                                                    />
                                                    {cardErrors.cvc && <div className="invalid-feedback">{cardErrors.cvc}</div>}
                                                </div>
                                                <div className="mt-4 col-12">
                                                    <div className="gap-3 p-3 border border-opacity-25 d-flex align-items-center justify-content-center rounded-3 bg-success bg-opacity-10 border-success">
                                                        <i className="fa-duotone fa-shield-check fa-xl text-success"></i>
                                                        <div>
                                                            <div className="fw-semibold text-success small">{t("Pago 100% seguro")}</div>
                                                            <div className="text-muted" style={{ fontSize: "0.75rem" }}>{t("Tus datos están cifrados y protegidos con SSL")}</div>
                                                        </div>
                                                        <i className="fa-brands fa-cc-visa fa-xl text-secondary"></i>
                                                        <i className="fa-brands fa-cc-mastercard fa-xl text-secondary"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-wrap gap-3 mt-4 d-flex justify-content-center">
                                <button type="button"
                                    onClick={toggleDadesInfoPagoClient}
                                    className="btn btn-outline-secondary"
                                >
                                    ← {t("Anterior")}
                                </button>
                                <button className="btn btn-primary"
                                    //onClick={() => ()}
                                    type="submit"
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {prepagoRef > 0 ?
                                        <>
                                            <i className="fa-duotone fa-credit-card me-1"></i>
                                            <span id="titulopagarmobile">{t("Pagar") + " " + t("Ahora")}</span>
                                        </>
                                        :
                                        <span id="titulopagarmobile">{t("Confirmar")}</span>
                                    }
                                </button>
                            </div>
                        </div>

                        {/* ***************** FIN TPV, PAYPAL, ETC ***************** */}
                    </form>

                    {/* Popup de política de cancel·lació — mateix disseny que
                        Buscar2/PropiedadesBuscar.jsx (no és el <Modal> de
                        react-bootstrap, és el mateix overlay fet a mà). */}
                    {modalPolitica && (
                        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} onClick={() => setModalPolitica(null)}>
                            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                                <div className="modal-content">
                                    <div className="pb-0 border-0 modal-header">
                                        <h6 className="modal-title fw-bolder">{modalPolitica.nombre}</h6>
                                        <button type="button" className="btn-close" onClick={() => setModalPolitica(null)}></button>
                                    </div>
                                    <div className="pt-2 modal-body">
                                        <p className="mb-0 small text-muted" dangerouslySetInnerHTML={{ __html: limpiarHtml(modalPolitica.descripcion) }}></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <Modal
                        show={showModal} onHide={() => setShowModal(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        size="lg"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{t("Error")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="clearfix mb-20 ml-20 row">
                                {t("Asegúrate de completar los campos marcados con *")}
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>


                <div className="col-md-5 col-lg-4">
                    <div className="mt-5 caixa-preus sticky-top">
                        <div className="bh-cart">
                            {
                                propiedades.map((propiedad, indexLinia) => {
                                    const key = "propiedad-" + propiedad.id + "-" + propiedad.precios.id;
                                    // propiedades porta una entrada per unitat (cantidad ja expandida), en
                                    // l'ordre de selecció: la N-èsima és l'habitació N del cercador.
                                    const hostesHabitacio = distribucion.length > 1 ? distribucion[indexLinia] : null;
                                    const politica = propiedad.precios.info_tarifa?.politica;
                                    const nombretarifa = propiedad.precios.info_tarifa?.nombre_web_traducido?.[lang]
                                        || propiedad.precios.info_tarifa?.nombre_web;

                                    return (
                                        <div className="bh-cart__item" key={key} data-key={key}>
                                            <div className="bh-cart__top">
                                                <div className="bh-cart__foto">
                                                    {
                                                        propiedad.foto_principal.length != 0
                                                            ? <img src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/thumb/" + propiedad.foto_principal[0].nombre} alt={propiedad.foto_principal[0].texto_alt ? propiedad.foto_principal[0].texto_alt[lang] : ""} title={propiedad.foto_principal[0].texto_title ? propiedad.foto_principal[0].texto_title[lang] : ""} />
                                                            : <img src="/images/web/bedloop-nofoto.png" alt="--" title="" />
                                                    }
                                                </div>
                                                <div className="bh-cart__preu">
                                                    <strong>{(propiedad.precios.suma / 100).toFixed(2)} {moneda}</strong>
                                                </div>
                                            </div>

                                            <div className="bh-cart__info">
                                                <h4>
                                                    {
                                                        propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ?
                                                            propiedad.nombre_traducido[lang]
                                                            :
                                                            propiedad.nombre
                                                    }
                                                </h4>
                                                {(nombretarifa || politica?.nombre?.[lang]) && (
                                                    <p className="bh-cart__subtitulo">
                                                        {nombretarifa}
                                                        {politica?.nombre?.[lang] && (
                                                            <>
                                                                {" ("}
                                                                <button
                                                                    type="button"
                                                                    className="bh-cart__politica"
                                                                    onClick={() => setModalPolitica({ nombre: politica.nombre?.[lang], descripcion: politica.descripcion?.[lang] })}
                                                                >
                                                                    {politica.nombre[lang]}
                                                                </button>
                                                                {")"}
                                                            </>
                                                        )}
                                                    </p>
                                                )}

                                                {llegada && salida && (
                                                    <span className="bh-cart__badge">
                                                        <i className="fa-regular fa-calendar"></i>
                                                        {formatoFechaLlarga(llegada)} - {formatoFechaLlarga(salida)}
                                                    </span>
                                                )}

                                                <div className="bh-cart__meta">
                                                    <span><i className="fa-regular fa-moon"></i> {cuentaNoches} {t("Noches")}</span>
                                                    {!hostesHabitacio && (
                                                        <span><i className="fa-regular fa-user"></i> {adultos} {t("Adultos")}{ninos > 0 ? ", " + ninos + " " + t("Niños") : ""}{bebes > 0 ? ", " + bebes + " " + t("Bebés") : ""}</span>
                                                    )}
                                                </div>
                                                {hostesHabitacio && (
                                                    <div className="bh-cart__hab">
                                                        <strong>{t("Habitación")} {indexLinia + 1}</strong>
                                                        <span>
                                                            <i className="fa-regular fa-user"></i> {hostesHabitacio.adultos} {hostesHabitacio.adultos == 1 ? t("Adulto") : t("Adultos")}
                                                            {hostesHabitacio.ninos > 0 && <>, {hostesHabitacio.ninos} {hostesHabitacio.ninos == 1 ? t("Niño") : t("Niños")}</>}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="bh-cart__bottom">
                                                <button
                                                    type="button"
                                                    className={"bh-cart__details" + (detallesAbiertos[key] ? " bh-cart__details--obert" : "")}
                                                    data-hab={indexLinia}
                                                    onClick={() => toggleDetalles(key)}
                                                >
                                                    {t("Detalles")} <i className="fa-solid fa-chevron-down"></i>
                                                </button>

                                                {detallesAbiertos[key] && (
                                                    <div className="bh-cart__grid">
                                                        <div className="bh-cart__grid-item">
                                                            <span>{t("Tarifa")}</span>
                                                            <strong>{nombretarifa || "—"}</strong>
                                                        </div>
                                                        <div className="bh-cart__grid-item">
                                                            <span>{t("Cancelación")}</span>
                                                            {politica?.nombre?.[lang] ? (
                                                                <strong>
                                                                    <button
                                                                        type="button"
                                                                        className="bh-cart__politica"
                                                                        onClick={() => setModalPolitica({ nombre: politica.nombre?.[lang], descripcion: politica.descripcion?.[lang] })}
                                                                    >
                                                                        {politica.nombre[lang]}
                                                                    </button>
                                                                </strong>
                                                            ) : (
                                                                <strong>—</strong>
                                                            )}
                                                        </div>
                                                        <div className="bh-cart__grid-item">
                                                            <span>{t("Habitaciones")}</span>
                                                            <strong>{propiedad.num_habitaciones ?? "—"}</strong>
                                                        </div>
                                                        <div className="bh-cart__grid-item">
                                                            <span>{t("Huéspedes")}</span>
                                                            <strong>{hostesHabitacio ? hostesHabitacio.adultos : adultos} {t("Adultos")}</strong>
                                                        </div>
                                                        <div className="bh-cart__grid-item bh-cart__grid-item--extras">
                                                            <span>{t("Extras")}</span>
                                                            <div className="bh-cart__extras" data-extras-hab={indexLinia}></div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <div className="mt-3 mb-3 text-start">
                            <button className="btn btn-primary"
                                onClick={() => handleBack()}
                                style={{ background: "" + websgrupo.color_corporativo_web + "", border: "1px solid" + websgrupo.color_corporativo_web }}
                            >
                                {t("Cambiar fechas")}
                            </button>
                        </div>

                        <h4>{t("Resumen")}</h4>
                        <div className="linia mb-3"></div>

                        <div className="mb-3 row">
                            <div className="col-4 text-end" style={{ display: "none" }}><span id="pextra" ref={pextraRef}></span> {moneda}</div>
                        </div>

                        <div className="mb-3 row muestra-codigo-carro" style={{ display: "none" }}>
                            <div className="col-8 mb-2">{t("Código")}</div>
                            <div className="col-4 text-end"><span className="codigo-carro"></span> {moneda}</div>
                        </div>

                        <div className="mt-2 mb-2 linia"></div>

                        <div className="mb-3 row">
                            <div className="col-8 fw-bolder">{t("Total")}</div>
                            <div className="col-4 text-end fw-bolder totalprice">{parseFloat(precioBase).toFixed(2)} {moneda} </div>
                        </div>


                        {mostrarPagar === 'block' &&
                            <div className="mt-3 mb-3 text-center row">
                                <button className="btn btn-primary"
                                    onClick={() => handleSubmit()}
                                    disabled={enviando}
                                    style={{ background: websgrupo.color_corporativo_web, border: "1px solid " + websgrupo.color_corporativo_web }}
                                >
                                    {enviando ? (
                                        <>
                                            <span
                                                className="spinner-border spinner-border-sm me-1"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                            {t("Procesando")}...
                                        </>
                                    ) : (
                                        <>
                                            {prepagoRef > 0 ?
                                                <>
                                                    <i className="fa-duotone fa-credit-card"></i> <span id="titulopagar">{t("Pagar") + " " + t("Ahora")}</span> <span className="prepago">
                                                        {
                                                            tpvs.length === 0 && config.activa_paypal === 0 && config.activa_stripe === 0 && config.activa_transferencia === 1 && transferencia && prepagoRef === 0 ?
                                                                0
                                                                :
                                                                roundN(importePrepago, 2)
                                                        }
                                                    </span> <span id="pagarmoneda">{moneda}</span>
                                                </>
                                                :
                                                <>
                                                    <span id="titulopagar">{t("Confirmar")}</span> <span className="prepago"></span> <span id="pagarmoneda"></span>
                                                </>
                                            }
                                        </>)}
                                </button>
                            </div>
                        }

                        <p className="mt-4 mb-0">
                            <input type="checkbox" name="aceptacondiciones" required defaultChecked id="aceptacondiciones" ref={aceptacondicionesRef} />
                            <span className="small ms-2 text-start">
                                {t("Al reservar, acepta los")}<a href={"/" + preidioma + t("terminos")} target="_blank">  {t("términos y condiciones")}</a>, {t("así como la")} <a href={"/" + preidioma + t("politica-de-cancelacion")} target="_blank">{t("política de cancelación")}</a>. *
                            </span>
                        </p>
                        <p className="mt-4 mb-0">
                            <input type="checkbox" name="aceptacondiciones2" id="aceptacondiciones2" />
                            <span className="small ms-2 text-start">
                                {t("Acepto recibir información comercial, incluso por medios electrónicos")}.
                            </span>
                        </p>
                        <p className="mt-5 mb-0 small fst-italic text-end"> * {t("Impuestos incluidos")}</p>
                    </div>

                </div>
            </div >
        </div >
    );
}

export default DatosReserva;
